// extracted by mini-css-extract-plugin
module.exports = {"PowerSolutions":"PowerSolutions_PowerSolutions__QKStr"};